import { createContext } from "react";

export const ModalActionContext = createContext<
  { handleConfirmAction: () => Promise<void>; closeModal: () => void } | undefined
>(undefined);
